module.exports = __webpack_public_path__ + "img/18.7e35c93b.png";